import { render, staticRenderFns } from "./HomeRedirect.vue?vue&type=template&id=368cb3e0&scoped=true"
import script from "./HomeRedirect.vue?vue&type=script&lang=js"
export * from "./HomeRedirect.vue?vue&type=script&lang=js"
import style0 from "./HomeRedirect.vue?vue&type=style&index=0&id=368cb3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368cb3e0",
  null
  
)

export default component.exports